<template>
  <div style="margin-bottom: 30px">
    <div style="margin-bottom: 20px">
      <Progress :percent="progressValue" :stroke-width="2" :stroke-color="['#108ee9', '#87d068']" />
    </div>
    <Row :gutter="100">
      <Col span="10" offset="1">
        <Form ref="scanCreateDataForm" :model="scanCreateData" label-position="left" :rules="ruleScanCreateData" label-width="20%">
          <FormItem prop="code" :label="$t('scanAddNewCase.code')">
            <Input v-model="scanCreateData.code" ref="inputFocus" :autofocus="true"  @keydown.native.enter="changeData" :placeholder="$t('scanAddNewCase.codePlaceholder')" />
          </FormItem>
          <FormItem prop="pathologyId" :label="$t('scanAddNewCase.pathologyId')">
            <Input v-model="scanCreateData.pathologyId" :placeholder="$t('scanAddNewCase.pathologyIdPlaceholder')" />
          </FormItem>
          <FormItem prop="slideCount" :label="$t('scanAddNewCase.slideCount')">
            <InputNumber :max="10" :min="1" v-model="scanCreateData.slideCount" :placeholder="$t('scanAddNewCase.slideCountPlaceholder')" style="width: 100%"/>
          </FormItem>
          <FormItem :label="$t('addNewCase.caseInfo.sentToHospital')" prop="hospitalId">
            <Select v-model="scanCreateData.hospitalId" filterable>
              <Option v-for="(item, index) in sendHospitalList" :value="item.value" :key="index">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem prop="sourceName" :label="$t('scanAddNewCase.sourceName')">
            <Select class="inputWidth" v-model="scanCreateData.sourceName">
              <Option v-for="(item, index) in sourceArray" :value="item.value" :key="index">{{ item.label }}</Option>
            </Select>
          </FormItem>
        </Form>
      </Col>
      <Col span="12">
        <div >
          <Card>
            <p slot="title">患者信息</p>
            <div v-if="patientInfo.patientName" style="text-align: center;">
              <div style="font-size: 80px;font-weight: bold;">{{ patientInfo.pathologyId }}</div>
              <div style="font-size: 80px;font-weight: bold;">{{ patientInfo.patientName }}</div>
              <div style="font-size: 80px;font-weight: bold;">{{patientInfo.patientSex}}</div>
              <div style="font-size: 80px;font-weight: bold;">{{patientInfo.patientAge}}</div>
              <div style="font-size: 50px;font-weight: bold;">{{ patientInfo.hospitalName  }}</div>
            </div>
          </Card>
        </div>
      </Col>
    </Row>
  </div>
</template>

<script>
export default {
  name: 'ScanCase',
  data () {
    return {
      $vue: '',
      progressValue: 0,
      canCreate: true,
      sendHospitalList: [],
      orderId: '',
      checkId: '',
      snCode: '',
      codeType: '',
      sourceArray: [],
      patientInfo: {
        patientName: '',
        patientSex: '',
        patientAge: '',
        hospitalName: ''
      },
      scanCreateData: {
        code: '',
        pathologyId: '',
        slideCount: 5,
        hospitalId: '',
        hosName: '',
        sourceName: ''
      },
      ruleScanCreateData: {
        code: [
          { required: true, message: '请扫描二维码信息', trigger: 'blur' },
          { validator: this.validateLink, trigger: 'blur' }
        ],
        pathologyId: [
          { required: true, message: '请填写病例号', trigger: 'blur' }
        ],
        slideCount: [
          {
            required: true,
            type: 'number',
            message: '请填写制片数量',
            trigger: ['change', 'blur']
          },
          {
            type: 'number',
            message: '必须为数字',
            trigger: ['change', 'blur']
          }
        ]
        // hospitalId: [
        //   { required: true, message: this.$t('addNewCase.caseInfo.sentToHospitalTip'), trigger: 'change' }
        // ]
      }
    }
  },
  computed: {},
  watch: {},
  beforeMount () {
    this.getCaseSourceList()
    this.getHospitalList()
  },
  methods: {
    validateLink (rule, value, callback) {
      const regex = /^https:\/\/app\.n-ecdc\.com\/entry\?code=([a-zA-Z0-9]+)$/
      if (value && !regex.test(value)) {
        callback(new Error('非法链接，请扫描正确的链接'))
      } else {
        callback()
      }
    },
    // 获取医院列表
    getHospitalList () {
      this.$http.post('casemanager/getHospitalList').then(suc => {
        if (suc.data.result === '1') {
          let data = suc.data.data
          this.sendHospitalList = data
          this.$nextTick(() => {
            this.$refs.inputFocus.$el.children[1].focus()
          })
        }
      })
    },
    changeData () {
      // 添加标识位防止多次创建
      if (this.canCreate) {
        this.progressValue = 0
        this.$refs['scanCreateDataForm'].validate((valid) => {
          if (!valid) {
            this.$Message.error('请填写完整信息')
            this.scanCreateData.code = ''
            this.$nextTick(() => {
              this.$refs.inputFocus.$el.children[1].focus()
            })
            return false
          }
          if (this.scanCreateData.code.indexOf('entry?code=') !== -1) {
            this.snCode = this.getQueryString(this.scanCreateData.code, 'code')
            this.checkId = this.snCode
            this.codeType = 'entry'
          } else {
            this.snCode = this.scanCreateData.code
            this.checkId = this.snCode
            this.codeType = 'order'
          }
          this.canCreate = false
          this.progressValue = 25
          this.scanImportCase()
        })
      } else {
        this.$Message.error('请勿重复创建,请等待。。。。。')
      }
    },
    scanImportCase () {
      let payload = {
        ORDER_NUM: this.snCode,
        codeType: this.codeType,
        hospitalId: this.scanCreateData.hospitalId,
        pathologyId: this.scanCreateData.pathologyId,
        slideCount: this.scanCreateData.slideCount,
        caseDepart: this.scanCreateData.sourceName
      }
      this.progressValue = 50
      this.$http.post('casemanager/scanImportCase', payload).then(res => {
        if (res.data.result === '1') {
          this.$Message.success('病例创建成功')
          this.progressValue = 100
          this.canCreate = true
          // 将字符创json转成对象
          const data = JSON.parse(res.data.data)
          this.scanCreateData.pathologyId = data.newPathologyId
          // 获取医院名称
          this.getHospitalName(data.hospitalId)
          this.scanCreateData.sourceName = data.caseDepart
          this.patientInfo.pathologyId = data.pathologyId
          this.patientInfo.patientName = data.name
          this.patientInfo.patientSex = data.sex
          this.patientInfo.patientAge = data.age
        } else {
          // 查询失败
          this.canCreate = true
          this.progressValue = 0
          this.$Message.error(res.data.data)
        }
        this.scanCreateData.code = ''
        this.$nextTick(() => {
          this.$refs.inputFocus.$el.children[1].focus()
        })
      })
    },
    // 根据医院id获取医院名称
    getHospitalName (hospitalId) {
      this.$http.post('casemanager/getHospitalNameByHospitalId', {
        hospitalId: hospitalId
      }).then(res => {
        if (res.data.result === '1') {
          this.patientInfo.hospitalName = res.data.data
        }
      })
    },
    getCaseSourceList () {
      this.sourceArray = []
      this.$http.post('casemanager/getCaseSourceList').then(res => {
        if (res.data.result === '1') {
          this.$nextTick(() => {
            res.data.data.forEach(e => {
              this.sourceArray.push({
                value: e.infoName,
                label: e.infoName
              })
            })
          })
        }
        console.log(this.sourceArray)
      })
    },
    getQueryString (url, name) {
      let reg = new RegExp('(^|&|\\?|/)' + name + '(=([^&]*))?(&|$|/)', 'i')
      let r = url.match(reg)
      if (r != null) {
        return r[3] !== undefined ? r[3] : ''
      }
      return null
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/base/addCase/ScanCase.vue